<template>
  <div
    :data-testid="`talking-point-${remark.id}`"
    class="tw-flex tw-flex-row tw-w-full tw-pe-8 tw-group"
    :class="backgroundClass"
  >
    <SfDragHandle :dragging="dragging" data-testid="talking-point-handle" />
    <div class="tw-grow">
      <RemarkCard
        :remark="remark"
        edit-modal-size="l"
        part-of="meeting_preparation"
        :show-context="hasContextOutsideMeeting(remark)"
        :show-context-btn="hasContextOutsideMeeting(remark)"
        show-period
        hide-read-status
        show-tags
        :exclude-tag-ids-in-card="excludedTagIdsInCard"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import SfDragHandle from '@app/shared/vue/components/sf-drag-handle/sf-drag-handle.vue'
import RemarkCard from '@app/shared/vue/components/molecules/remark/remark-card.vue'
import type { Remark } from '@app/application/communication/types'
import { useTalkingPointTag } from '@app/application/client_meetings/composables/use-talking-point-tag'
import { hasContextOutsideMeeting } from '@app/application/client_meetings/utils/remark-context'

interface Props {
  remark: Remark
  handleClass: string
  dragging: boolean
}

const props = defineProps<Props>()

const { talkingPointTagIds: excludedTagIdsInCard } = useTalkingPointTag()

const backgroundClass = computed(() => ({
  'hover:tw-bg-sf-snow-dark hover:tw-rounded-lg active:tw-bg-sf-snow-dark':
    !props.dragging,
}))
</script>

<style scoped lang="scss">
[draggable='true'] {
  opacity: 0.5;
}
</style>
